// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sbl.sbl--title-large{padding:0 10px;font-family:Roboto,Helvetica,sans-serif;font-size:3.75rem;font-weight:900;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;text-align:left;color:#000;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
